import { Component, Inject, OnInit } from '@angular/core';
// import { inject } from '@angular/core/testing';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ServerService } from 'src/app/services/server.service';
@Component({
  selector: 'app-cancelled-status',
  templateUrl: './cancelled-status.component.html',
  styleUrls: ['./cancelled-status.component.scss']
})
export class CancelledStatusComponent implements OnInit {
token = localStorage.getItem('token')
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<CancelledStatusComponent>,
    private _serverService:ServerService
  ) {
   }

  ngOnInit() {
  }
close(){
  this.dialogRef.close()
}
save(){
  let body={
    status:'Cancelled'
  }
  
  this._serverService.updateMediaPlanRequest(this.data,body,this.token).subscribe((data)=>{
    // console.log(data)
    this.dialogRef.close(data)
  })
}
}
